import React, {useState, useEffect, useRef, useContext} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import {numbers, specialCharTextNumbers} from '../../views/textNumber-input/text-number';
import TextNumberEntryView from '../../views/textNumberEntryView';
import NumberView from '../../views/numberTNView';
import MenuContext from '../../../context/menuContext';

function MessageTN({onExit, isDisabled}) {
  const [value, setValue] = useState(10);

  return (
    <TextNumberEntryView
      chars={specialCharTextNumbers}
      focus={3}
      onChange={v => setValue(v)}
      defaultKey1={0}
      defaultKey2={0}
      defaultKey3={54}
      defaultKey4={50}
      defaultKey5={57}
      defaultKey6={58}
      defaultKey7={65}
      defaultKey8={0}
      defaultKey9={54}
      defaultKey10={50}
      defaultKey11={55}
      defaultKey12={58}
      onSave={onExit}
      onLeftHold={onExit}
      title="Set Informational Message"
      caption="0x34, 0x14, 0xD4, 0x15, 0x28, 0x12"
      left="Hold to Cancel"
      right="Hold to Save"
    />
  );
}

export default MessageTN;
